import React, { useState, useEffect } from 'react';
import Landing from "components/products/Landing";
import OiCarousel from "components/shared/OiCarousel";

const LANDING_CAROUSEL_BREAKPOINTS = [
  { minWidth: 375, slidesPerView: 1.2 },
  { minWidth: 425, slidesPerView: 1.2 },
  { minWidth: 768, slidesPerView: 2.2 },
  { minWidth: 1024, slidesPerView: 4 },
  { minWidth: 1280, slidesPerView: 5 },
];

function CarouselLanding(props) {
  const [landings, setLandings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [slidesSkeletons, setSlidesSkeletons] = useState(1);

  useEffect(() => {
    const updateSkeletonCount = () => {
      const width = window.innerWidth;
      if (width >= 1280) setSlidesSkeletons(5);
      else if (width >= 1024) setSlidesSkeletons(4);
      else if (width >= 768) setSlidesSkeletons(2);
      else if (width >= 425) setSlidesSkeletons(1);
      else setSlidesSkeletons(1);
    };
    updateSkeletonCount();
    window.addEventListener("resize", updateSkeletonCount);
    return () => window.removeEventListener("resize", updateSkeletonCount);
  }, []);

  useEffect(() => {
    if (props.landings) {
      setLandings(props.landings);
      setLoading(false);
    }
  }, [props.landings]);

  const image_format = landings.length <= 2 ? "large" : "medium";
  const skeleton_height = 330;

  return (
    <section className="caroussel">
      <section className="products-section">
        {loading ? (
          <section className="carousel-skeletons-loader carousel-home__skeleton-row">
            {Array.from({ length: slidesSkeletons }).map((_, idx) => (
              <div
                key={`landing-skeleton-${idx}`}
                className="carousel-home__skeleton-cell--landing landing-loader oi-skeleton oi-skeleton--wave oi-skeleton--rounded"
                style={{ height: skeleton_height }}
                aria-hidden
              />
            ))}
          </section>
        ) : (
          <OiCarousel
            className="carousellanding"
            items={landings && landings.length > 0 ? landings : []}
            gap={24}
            breakpoints={LANDING_CAROUSEL_BREAKPOINTS}
            ariaLabel="Landings destacados"
            getItemKey={(landing) => `landing-label-${landing.id}`}
            renderItem={(landing) => (
              <Landing
                landing={landing}
                image_format={image_format}
                skeleton_height={skeleton_height}
                curent_locale={props.current_locale}
                skeleton_animation="none"
              />
            )}
          />
        )}
      </section>
    </section>
  );
}

export default CarouselLanding;
